import React, { useEffect, useState } from "react";
import { Grid, Dialog } from "@material-ui/core";
import Notification from "./Notification/Notification";
import OfficeContact from "./OfficeContact/OfficeContact";
import Resource from "./Resource/Resource";
import Offices from "./OfficeContact/Offices";
import TimeOffAvailability, {
  TimeOffHistoryModal,
} from "./TimeOffAvailability/TimeOffAvailability";
import PendingTimeOffRequests from "./PendingTimeOffRequests/PendingTimeOffRequests";
import UnlockRequests from "./UnlockRequest/UnlockRequests";
import { hasPermission } from "../Common/permission";
import useStyles from "./Style/style";

import SnackbarComponent from "../Common/Snackbar";

const Dashboard = (props) => {
  const classes = useStyles();
  
  // Use clean, semantic CSS class for all dashboard panels
  const stablePanelCss = classes.dashboardPanel;

  const [showTimeOffHistory, setShowTimeOffHistory] = useState(null);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [severity, setSeverity] = useState("success");



  // Clear localStorage of firstlogin flag if left over from user login
  useEffect(() => {
    if (props.user && localStorage.getItem("firstLogin")) {
      localStorage.removeItem("firstLogin");
    };
    // setLeftDec({"1":3,"2":3,"3":3,"4":3})
  }, [props.user]);




  if (window.location.hash) {
    window.location.href = window.location.href.split("#")[0];
  }

  const handleSnackBarClose = () => {
    setSnackBarOpen(false);
  };

  return (
    <div style={{overflow:"hidden",padding:20}}>
      <SnackbarComponent
        message={snackBarMessage}
        open={snackBarOpen}
        handleSnackBarClose={handleSnackBarClose}
        severity={severity}
      ></SnackbarComponent>
      {showTimeOffHistory && (
        <Dialog
          fullWidth
          maxWidth="lg"
          open={Boolean(showTimeOffHistory)}
          onClose={() => {
            setShowTimeOffHistory(null);
          }}
        >
          <div className={classes.popupDialog} style={{ padding: 10 }}>
            <TimeOffHistoryModal
              {...props}
              handleClose={() => {
                setShowTimeOffHistory(null);
                if (props.handleClose) {
                  props.handleClose();
                }
              }}
              onClose={() => {
                setShowTimeOffHistory(null);
              }}
            />
          </div>
        </Dialog>
      )}
      <Grid container spacing={6}>
        {/* Left */}
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <Grid container spacing={6} className={classes.dashboardGrid}>
            <Grid item xs={12} className={classes.panelWrapper}>
              <Grid
                container
                spacing={3}
                className={stablePanelCss}
              >
                <Grid item xs={12}>
                  <Notification {...props} setNoti={() => {}} />
                </Grid>
              </Grid>
            </Grid>
            {hasPermission(props, ["Lock Documents"]) && (
              <Grid item xs={12} className={classes.panelWrapper}>
                <Grid
                  container
                  spacing={3}
                  className={stablePanelCss}
                >
                  <Grid item xs={12}>
                    <UnlockRequests {...props} setDoc={() => {}} />
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item xs={12} className={classes.panelWrapper}>
              <Grid
                container
                spacing={3}
                className={stablePanelCss}
              >
                <Grid item xs={12}>
                  <Resource {...props} setLink={() => {}} />
                </Grid>
              </Grid>
            </Grid>
            {hasPermission(props, ["HR"]) &&
							props.tenant &&
              props.tenant.is_hr_module_available &&
              props.user && props.user.reporting_employees_count > 0 && (

                <Grid item xs={12} className={classes.panelWrapper}>
                  <Grid
                    container
                    spacing={3}
                    className={stablePanelCss}
										>
                    <Grid item xs={12}>
                      <PendingTimeOffRequests
                        {...props}
                        setPending={() => {}}
                        setShowTimeOffHistory={setShowTimeOffHistory}
                        setSnackBarMessage={setSnackBarMessage}
                        setSnackBarOpen={setSnackBarOpen}
                        setSeverity={setSeverity}
										/>
                    </Grid>
                  </Grid>
                </Grid>)}
          </Grid>
        </Grid>
        {/* right */}
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <Grid container direction="column" spacing={6} className={classes.dashboardGrid}>
            {hasPermission(props, ["HR"]) &&
							props.tenant &&
              props.tenant && props.tenant.is_hr_module_available && (
                <Grid item xs={12} className={classes.panelWrapper}>
                  <Grid
                    container
                    spacing={3}
                    className={stablePanelCss}
                  >
                    <Grid item xs={12}>
                      <TimeOffAvailability
                        {...props}
                        setTimeOff={() => {}}
                        setShowTimeOffHistory={setShowTimeOffHistory}
                        setSnackBarMessage={setSnackBarMessage}
                        setSnackBarOpen={setSnackBarOpen}
                        setSeverity={setSeverity}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            <Grid item xs={12} className={classes.panelWrapper}>
              <Grid
                container
                spacing={3}
                className={stablePanelCss}
              >
                <Grid item xs={12}>
                  <OfficeContact {...props} setContact={() => {}} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.panelWrapper}>
              <Grid
                container
                spacing={3}
                className={stablePanelCss}
              >
                <Grid item xs={12}>
                  <Offices {...props} setOffices={() => {}} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

// </Grid>
// <Grid item xs={12} sm={12} md={12} lg={6}>

export default Dashboard;
